import * as THREE from 'three';
import Application from '../Application';
import { COFFEE_STEAM_CONFIG } from './deskSceneConfig';
// @ts-ignore
import fragmentShader from '../Shaders/coffee/fragment.glsl';
// @ts-ignore
import vertexShader from '../Shaders/coffee/vertex.glsl';
export default class CoffeeSteam {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.time = this.application.time;
        this.model = null;
        if (COFFEE_STEAM_CONFIG.enabled)
            this.setModel();
    }
    setModel() {
        const { position, size, color } = COFFEE_STEAM_CONFIG;
        this.model = {};
        const initialColor = new THREE.Color(color !== null && color !== void 0 ? color : '#c9c9c9');
        this.model.material = new THREE.ShaderMaterial({
            transparent: true,
            depthWrite: false,
            toneMapped: false,
            vertexShader,
            fragmentShader,
            uniforms: {
                uTime: { value: 0 },
                uTimeFrequency: { value: 0.001 },
                uUvFrequency: { value: new THREE.Vector2(3, 5) },
                uColor: { value: initialColor },
            },
        });
        this.model.mesh = new THREE.Mesh(new THREE.PlaneGeometry(size[0], size[1]), this.model.material);
        this.model.mesh.position.set(position[0], position[1], position[2]);
        this.scene.add(this.model.mesh);
    }
    update() {
        var _a, _b;
        if (!((_a = this.model) === null || _a === void 0 ? void 0 : _a.material))
            return;
        this.model.material.uniforms.uTime.value = this.time.elapsed;
        const color = (_b = COFFEE_STEAM_CONFIG.color) !== null && _b !== void 0 ? _b : '#c9c9c9';
        this.model.material.uniforms.uColor.value.setStyle(color);
    }
}
